(() => {
  'use strict';
  const root = document.querySelector('[data-family-set]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const variants = JSON.parse(root.querySelector('[data-family-variants]').textContent);
  const form = root.querySelector('[data-family-form]');
  const sons = root.querySelector('[data-sons]');
  const submit = root.querySelector('[data-family-submit]');
  const addButton = root.querySelector('[data-add-son]');
  const error = root.querySelector('[data-family-error]');
  const currency = root.dataset.currency || 'USD';
  const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency}).format(cents / 100);
  const maxSons = Math.max(...variants.map(v => Number(v.sons)));
  const base = variants.find(v => v.dad === 'S' && Number(v.sons) === 1);
  const two = variants.find(v => v.dad === 'S' && Number(v.sons) === 2);
  if (!base || !two) { error.textContent='This matching set is being prepared. Please contact us to order.'; error.hidden=false; return; }
  const childPrice = two.price - base.price;
  const ordinal = n => n % 100 >= 11 && n % 100 <= 13 ? n+'th' : n + ({1:'st',2:'nd',3:'rd'}[n%10] || 'th');
  let busy = false;
  const childRows = () => [...sons.querySelectorAll('[data-person="son"]')];
  const people = () => [...root.querySelectorAll('[data-person]')];
  const dadSize = () => root.querySelector('[name="dad-size"]:checked')?.value;
  const chosen = () => variants.find(v => v.dad === (dadSize() || 'S') && Number(v.sons) === childRows().length);
  function clearError() { error.hidden=true; error.textContent=''; root.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid')); }
  function fail(message, field) { error.textContent=message; error.hidden=false; if(field){field.classList.add('is-invalid');field.scrollIntoView({behavior:'smooth',block:'center'});field.focus({preventScroll:true});} }
  function update() {
    const rows = childRows();
    rows.forEach((row,i) => {
      const who = 'Son '+(i+1);
      row.dataset.who=who;
      row.querySelector('[data-son-title]').textContent=who+'’s shirt';
      row.querySelector('[data-son-size-label]').textContent=who+'’s size *';
      row.querySelector('[data-son-size]').setAttribute('aria-label',who+'’s size');
      row.querySelector('[data-face]').setAttribute('aria-label','Upload '+who+'’s face');
      if(!row.querySelector('[data-face]').files.length) row.querySelector('[data-photo-label]').textContent='+ Upload '+who+'’s face';
      row.querySelector('[data-person-price]').textContent=money(childPrice);
      row.querySelector('[data-remove-son]').hidden=i===0;
    });
    const variant=chosen();
    const total=variant?.price;
    const single=variants.find(v=>v.dad===(dadSize()||'S') && Number(v.sons)===1);
    root.querySelector('[data-person="dad"] [data-person-price]').textContent=single ? money(single.price-childPrice) : '';
    root.querySelector('[data-family-price]').textContent=(dadSize()?'':'From ')+(total !== undefined?money(total):'Unavailable');
    root.querySelector('[data-set-total]').textContent=total !== undefined?money(total):'—';
    root.querySelector('[data-set-count]').textContent='1 dad + '+rows.length+' '+(rows.length===1?'son':'sons')+' · '+(rows.length+1)+' shirts';
    root.querySelector('[data-selection-summary]').textContent=['Dad: '+(dadSize()||'choose size'), ...rows.map((r,i)=>'Son '+(i+1)+': '+(r.querySelector('[data-son-size]').value||'choose size'))].join(' · ');
    root.querySelector('[data-extra-price]').textContent='(+'+money(childPrice)+')';
    addButton.hidden=rows.length>=maxSons;
    root.querySelector('[data-limit]').hidden=rows.length<maxSons;
    submit.disabled=busy;
    submit.textContent=busy?'Uploading photos & adding set…':'Add matching set to cart';
  }
  function addSon(focus=false) {
    if(childRows().length>=maxSons) return;
    const row=root.querySelector('[data-son-template]').content.cloneNode(true);
    sons.appendChild(row);update();
    if(focus) childRows().at(-1).querySelector('select').focus();
  }
  addButton.addEventListener('click',()=>{clearError();addSon(true);});
  sons.addEventListener('click',event=>{
    const remove=event.target.closest('[data-remove-son]');
    if(!remove || busy) return;
    const row=remove.closest('[data-person]');
    if(row===childRows()[0]) return;
    const image=row.querySelector('img');if(image.dataset.preview) URL.revokeObjectURL(image.dataset.preview);
    row.remove();clearError();update();addButton.focus();
  });
  root.addEventListener('change',event=>{
    clearError();
    const input=event.target;
    if(!input.matches('[data-face]')) {update();return;}
    const wrap=input.closest('.cas-family-upload');
    const image=wrap.querySelector('img');
    if(image.dataset.preview) URL.revokeObjectURL(image.dataset.preview);
    delete input.dataset.valid;image.hidden=true;image.removeAttribute('src');wrap.classList.remove('has-photo');
    const file=input.files[0];
    const who=input.closest('[data-person]').dataset.who||'Dad';
    wrap.querySelector('[data-photo-label]').textContent='+ Upload '+who+'’s face';
    wrap.querySelector('[data-photo-status]').textContent='One clear face · JPG, PNG or WebP · up to 10 MB';
    if(!file) return;
    if(!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size>10*1024*1024 || !file.size){input.value='';fail('Please use a JPG, PNG or WebP image under 10 MB.',input);return;}
    const url=URL.createObjectURL(file);image.dataset.preview=url;
    image.onload=()=>{if(input.files[0]!==file) return;input.dataset.valid='true';image.hidden=false;wrap.classList.add('has-photo');wrap.querySelector('[data-photo-label]').textContent='Photo selected · Replace';wrap.querySelector('[data-photo-status]').textContent=file.name;};
    image.onerror=()=>{if(input.files[0]!==file) return;input.value='';delete input.dataset.valid;image.hidden=true;URL.revokeObjectURL(url);fail('We could not read this image. Please choose another JPG, PNG or WebP.',input);};
    image.src=url;
  });
  form.addEventListener('submit',async event=>{
    event.preventDefault();event.stopImmediatePropagation();
    if(busy) return;
    clearError();
    if(!dadSize()){fail('Please choose Dad’s size.',root.querySelector('[name="dad-size"]'));return;}
    const rows=childRows();
    for(let i=0;i<rows.length;i++){const select=rows[i].querySelector('[data-son-size]');if(!select.value){fail('Please choose Son '+(i+1)+'’s size.',select);return;}}
    const all=people();
    for(let i=0;i<all.length;i++){const input=all[i].querySelector('[data-face]');if(!input.files[0]||input.dataset.valid!=='true'){fail('Please select a clear photo for '+(i===0?'Dad':'Son '+i)+' before adding your set.',input);return;}}
    const variant=chosen();
    if(!variant || !variant.available){fail('This set is currently unavailable. Please choose another size or contact us.');return;}
    const data=new FormData();
    data.append('id',String(variant.id));data.append('quantity','1');
    const prop=(key,value)=>data.append('properties['+key+']',String(value));
    prop('Matching set','1 dad + '+rows.length+' '+(rows.length===1?'son':'sons')+' ('+(rows.length+1)+' shirts)');
    prop('Dad size',dadSize());rows.forEach((row,i)=>prop('Son '+(i+1)+' size',row.querySelector('[data-son-size]').value));
    prop('Faces to print','All uploaded faces on every shirt');prop('Shirt lettering','Dad: PAPA; all sons: MINI');
    prop('No. of Pets / People / Logo',all.length);
    prop('Photo order',['1: Dad',...rows.map((_,i)=>(i+2)+': Son '+(i+1))].join('; '));
    all.forEach((row,i)=>{const file=row.querySelector('[data-face]').files[0];data.append('properties['+ordinal(i+1)+' Pet / Person / Logo Photos]',file,file.name);});
    const notes=root.querySelector('[data-design-notes]').value.trim();if(notes) prop('Design notes',notes);
    busy=true;form.setAttribute('aria-busy','true');update();
    form.querySelectorAll('input,select,textarea,button').forEach(el=>el.disabled=true);
    let added=false;
    try{
      const response=await fetch(root.dataset.addUrl,{method:'POST',body:data,headers:{Accept:'application/json'}});
      const result=await response.json();
      if(!response.ok) throw new Error(result.description || 'We could not add this set. Please try again.');
      added=true;submit.textContent='Set added · Opening cart…';window.location.assign(root.dataset.cartUrl);
    }catch(err){
      fail(err instanceof TypeError ? 'Connection interrupted. Please check your cart before trying again so your set is not added twice.' : err.message);
    }finally{
      if(!added){busy=false;form.removeAttribute('aria-busy');form.querySelectorAll('input,select,textarea,button').forEach(el=>el.disabled=false);update();}
    }
  },true);
  addSon();
})();
